import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {browserHistory} from 'react-router';
import styles from './MainPage.scss';
import * as actions from '../../redux/categoriesActions';
import CarBrandList from './elements/MainPageCarBrandList';
// import SeenBlock from '../SeenBlock/SeenBlock';


import CategoriesGrid from './elements/MainPageCategoriesGrid';
import PartnershipBlock from '../PartnershipBlock/PartnershipBlock';
import PartnershipBlockMobile from '../PartnershipBlock/PartnershipBlockMobile';
import Media from 'react-responsive';


export class MainPage extends Component {

  render() {
    return (
      <div className={ styles.mainPage }>
        {/* <CarBrandList
          brandList={this.props.brandList}
          getBrands={this.props.actions.getBrands}/>
        <CategoriesGrid />
        <Media query="(min-width: 1025px)">
          <PartnershipBlock />
        </Media>
        <Media query="(max-width: 1024px)">
          <PartnershipBlockMobile />
        </Media> */}
      </div>
    );
  }
}

MainPage.propTypes = {
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    ...state.categoriesReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage);



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/MainPage.jsx
 **/